gsap.registerPlugin(ScrollTrigger, Flip);

// Hero Image Parallax
let hero = document.querySelector('.js-hero'),
  bg = hero;

if (window.innerWidth > 768) {
  gsap.fromTo(
    bg,
    {
      y: 0,
    },
    {
      y: 100,
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true, // to make it responsive
      },
    },
  );
}

// Logo Transform

let logoAnim;

function anim() {
  logoAnim && logoAnim.revert();

  const logo = document.querySelector('.logo'),
    hero = document.querySelector('.js-hero'),
    header = document.getElementById('global-header');

  let logoHeight = logo.offsetHeight,
    vpHeight = window.innerHeight,
    setY = vpHeight - logoHeight;

  hero.appendChild(logo);
  logo.style.cssText = '';

  logoAnim = gsap.context(() => {
    const state = Flip.getState(logo, { props: 'bottom,color,transform,width' });

    header.appendChild(logo);

    const flip = Flip.from(state, {
      absolute: true,
      clearProps: 'all', // スタイルのリセット
    });

    if (window.innerWidth > 768) {
      ScrollTrigger.create({
        trigger: hero,
        start: 'top top',
        // endTrigger に #global-header を使っていたが、この要素は
        // position: fixed のため「下端が画面上端に到達する」条件が成立せず、
        // ScrollTrigger.refresh() が走った時点のスクロール位置で end が
        // 決まってしまう。ページ高やリフレッシュのタイミングで進行区間が
        // 潰れ、ロゴが即座に終端へ飛ぶ原因になっていたため hero に変更する。
        endTrigger: hero,
        end: 'bottom top',
        scrub: true,
        animation: flip,
        // invalidateOnRefresh: window.innerWidth <= 768, // 768px以下でのみ有効
        onUpdate: (self) => {
          const progress = self.progress; // 0から1の間の値
          const newTop = 20 * progress; // 例: topを0から100pxの間で変化させる
          logo.style.top = `${newTop}px`;
        },
      });
    }
  });
}

if (window.innerWidth > 768) {
  anim();
  ScrollTrigger.refresh();

  window.addEventListener('load', () => {
    anim();
    ScrollTrigger.refresh();
  });

  // リサイズ時に再計算
  window.addEventListener('resize', () => {
    setTimeout(() => {
      anim();
      ScrollTrigger.refresh();
    }, 100);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    const logo = document.querySelector('.logo');
    const headerLogo = document.querySelector('.js-header-logo');
    const fadeStart = 0; // フェードアウトを開始するスクロール位置
    const fadeEnd = 100; // フェードアウトが完了するスクロール位置

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      let logoOpacity = 1;
      let headerLogoOpacity = 0;

      if (scrollY > fadeStart) {
        logoOpacity = 1 - (scrollY - fadeStart) / (fadeEnd - fadeStart);
        logoOpacity = Math.max(logoOpacity, 0); // 不透明度が0未満にならないようにする

        headerLogoOpacity = (scrollY - fadeStart) / (fadeEnd - fadeStart);
        headerLogoOpacity = Math.min(headerLogoOpacity, 1); // 不透明度が1を超えないようにする
      }

      logo.style.opacity = logoOpacity;
      headerLogo.style.opacity = headerLogoOpacity;
    });
  });
}
